import { render } from "./PaiementStripePage.vue?vue&type=template&id=9a00a9ea&ts=true"
import script from "./PaiementStripePage.vue?vue&type=script&lang=ts"
export * from "./PaiementStripePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__